import { mapGetters } from 'vuex'

const COMPANY_MODULE_FLAG = 'newfront_company_module_enabled'
const NEWFRONT_CLIENTS_URL = '/newfront/company/clients'
const LEGACY_COMPANY_PATH = '/client'

export default {
  computed: {
    ...mapGetters(['isAdmin', 'isMaster']),
    canCreate() {
      return this.isAdmin || this.isMaster
    }
  },
  created() {
    if (this.canCreate && !this.isCompanyModuleFlagLoaded()) {
      this.$store.dispatch('systemFeatures/fetchFlag', COMPANY_MODULE_FLAG)
    }
  },
  methods: {
    isCompanyModuleFlagLoaded() {
      return (
        this.$store.state.systemFeatures.flags[COMPANY_MODULE_FLAG] !==
        undefined
      )
    },
    async goToCreate() {
      if (!this.isCompanyModuleFlagLoaded()) {
        await this.$store.dispatch(
          'systemFeatures/fetchFlag',
          COMPANY_MODULE_FLAG
        )
      }

      if (
        this.$store.getters['systemFeatures/isEnabled'](COMPANY_MODULE_FLAG)
      ) {
        window.location.href = NEWFRONT_CLIENTS_URL
        return
      }

      this.$router.push(LEGACY_COMPANY_PATH).catch(() => {})
    }
  }
}
